<template>
  <transition name="searches-status-modal">
    <div class="modal is-active">
      <div class="modal-background"></div>
      <div class="modal-content">
        <div class="box">
          <h1 class="mb-2 is-size-4">
            {{ $t('searchesStatusModal.title') }}
          </h1>

          <ul class="mt-2">
            <li
              v-for="(searchStore, idx) in savedSearchesStore"
              :key="searchStore.name"
              :class="{ 'has-background-white-ter': idx % 2 === 0 }"
              class="is-flex is-align-items-center p-1"
            >
              <button
                class="button is-small is-ghost"
                @click="() => onResetStatusClick(searchStore)"
              >
                <span class="icon is-small has-text-danger">
                  <fa-icon :icon="['fas', 'times']" />
                </span>
              </button>

              <span class="is-flex-grow-1 ml-2">
                {{ $t(`searchesStatusModal.stores.${searchStore.name}`) }}
              </span>

              <span class="pr-2 ml-2">
                {{
                  $t('searchesStatusModal.expiresInLabel', {
                    expiration: $date.duration(searchStore.expiresIn, 'seconds').humanize()
                  })
                }}
              </span>
            </li>
          </ul>

          <p v-if="savedSearchesStore.length === 0" class="mt-2 has-text-gray is-italic">
            {{ $t('searchesStatusModal.emptySearchesStore') }}
          </p>

          <div class="buttons are-centered mt-4">
            <button class="button is-light is-small" @click="onClose">
              {{ $t('searchesStatusModal.closeButton') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import allSearchesStores from '@/utils/searches_store/all'

const isSaved = searchStoreService => {
  const data = searchStoreService.read()
  return data !== null && data !== undefined
}

export default {
  name: 'SearchesStatusModal',
  data: () => ({
    allSearchesStores: []
  }),
  computed: {
    savedSearchesStore() { return this.allSearchesStores.filter(({ saved }) => saved) }
  },
  mounted() {
    this.allSearchesStores = allSearchesStores.map(searchStore => ({
      ...searchStore,
      saved: isSaved(searchStore.service),
      expiresIn: searchStore.service.expiresIn()
    }))
  },
  methods: {
    onResetStatusClick(searchStore) {
      searchStore.service.clear()
      searchStore.saved = false
    },
    onClose() {
      this.$emit('close')
    }
  }
}
</script>

<style>
.searches-status-modal-enter-active, .searches-status-modal-leave-active {
  transition: all 0.2s;
}
.searches-status-modal-enter, .searches-status-modal-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>